<template>
    <v-container fluid>
        <v-card outlined>
            <v-card-subtitle>
                Endoso tipo <strong>A</strong> altas de beneficiados. Selecciona un colectivo.
            </v-card-subtitle>
            <v-card-text>
                <v-row>
                    <!-- Selector de colectivos y botón de descarga -->
                    <v-col cols="12" m="2" md="5" lg="4">
                        <select-colectivos :colectivos="colectivos" @colectivo-change="changeColectividad">
                        </select-colectivos> Detalles
                    </v-col>
                    <v-col>
                        <v-btn v-show="idcolectividadSelect" color="azul_med" @click="DescargaZip" dark>
                            Descargar tarjetas
                        </v-btn>
                    </v-col>
                </v-row>
                <v-col v-show="idcolectividadSelect">
                    <p><strong>ACTIVAS: </strong> {{ this.activas }} </p>
                    <p v-for="plan in this.planesUnicos" :key="plan.nombre">
                        <strong>{{ plan.nombre }}: </strong> {{ plan.cantidad }}
                    </p>
                    <p><strong>SUSPENDIDAS: </strong>{{ this.suspendidas }}</p>
                    <p><strong>BAJAS: - </strong>{{ this.totalbajas }}</p>

                </v-col>
                <v-form ref="form" v-model="isValid">
                    <v-row v-show="idcolectividadSelect" class="mt-1">
                                                <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                            <v-select v-model="nuevo.Tipo" :rules="[rules.ruleRequired]" :items="['INDIVIDUAL', 'FAMILIAR']" label="Tipo" dense
                                outlined />
                        </v-col>
                        <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                            <v-select label="Sexo" v-model="nuevo.Sexo" :items="['MASCULINO', 'FEMENINO']" outlined
                                :rules="[rules.ruleRequired]" dense></v-select>
                        </v-col>
                        <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                            <v-text-field v-model="nuevo.Nombres" :rules="[rules.ruleNombre, rules.ruleRequired]"
                                label="Nombre(s)" outlined dense
                                @input="toUpperCaseGeneral(nuevo, 'Nombres')"></v-text-field>
                        </v-col>
                        <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                            <v-text-field v-model="nuevo.APaterno" :rules="[rules.ruleNombre, rules.ruleRequired]"
                                label="Apellido paterno" outlined dense
                                @input="toUpperCaseGeneral(nuevo, 'APaterno')"></v-text-field>
                        </v-col>
                        <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                            <v-text-field v-model="nuevo.AMaterno"  label="Apellido materno"
                                outlined dense @input="toUpperCaseGeneral(nuevo, 'AMaterno')"></v-text-field>
                        </v-col>

                        <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                            <v-text-field v-model="nuevo.Email" :rules="[rules.ruleEmail]" label="Correo" outlined
                                dense></v-text-field>
                        </v-col>
                        <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                            <v-text-field v-model="nuevo.NumTel" :rules="[rules.ruleTelephone]" v-mask="'###-###-####'"
                                label="Teléfono" outlined dense></v-text-field>
                        </v-col>
                        <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                            <v-text-field v-model="nuevo.RFC" label="RFC" :rules="[rules.ruleRfc]" outlined dense
                                @input="toUpperCaseGeneral(nuevo, 'RFC')"></v-text-field>
                        </v-col>
                        <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                            <v-text-field v-model="nuevo.FechaNac" label="Fecha Nacimiento" type="date" dense
                                outlined />
                        </v-col>
                        <v-col>
                            <v-btn color="primary" @click="agregarRenglon">Agregar</v-btn>
                        </v-col>

                    </v-row>
                </v-form>
                <!-- Tabla -->
                <v-data-table :headers="headers" :items="renglones" class="elevation-1" dense>
                    <template v-slot:[`item.acciones`]="{ item }">
                        <v-btn icon small color="red" @click="eliminarRenglon(item)">
                            <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                        <v-btn v-if="item.Tipo === 'FAMILIAR'" icon small color="blue"
                            @click="abrirBeneficiarios(item)">
                            <v-icon small>mdi-account-multiple-plus</v-icon> {{ item.Beneficiarios.length }}
                        </v-btn>
                    </template>
                </v-data-table>
                <v-col>
                    <v-btn color="success" class="mt-4" :disabled="renglones.length === 0" @click="guardar">
                        Generar Endoso
                    </v-btn>
                </v-col>

            </v-card-text>
        </v-card>
        <!-- Dialogo beneficiarios -->
        <v-dialog v-model="dialogBeneficiarios" max-width="80%">
            <v-card>
                <v-card-title>
                    Beneficiarios de {{ seleccionado?.Nombres }}
                </v-card-title>
                <v-card-text>
                    <v-form ref="formBeneficiados" v-model="isValidBen">
                        <v-row>
                            <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                                <select-parentesco :items="Parentescos" @colectivo-change="changeParentesco">
                                </select-parentesco>
                            </v-col>
                            <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                                <v-select label="Sexo" v-model="benefNuevo.Sexo" :items="['MASCULINO', 'FEMENINO']" outlined
                                    :rules="[rules.ruleRequired]" dense></v-select>
                            </v-col>
                            <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                                <v-text-field v-model="benefNuevo.Nombres" :rules="[rules.ruleNombre, rules.ruleRequired]"
                                    label="Nombre(s)" outlined dense
                                    @input="toUpperCaseGeneral(benefNuevo, 'Nombres')"></v-text-field>
                            </v-col>
                            <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                                <v-text-field v-model="benefNuevo.APaterno" :rules="[rules.ruleNombre, rules.ruleRequired]"
                                    label="Apellido paterno" outlined dense
                                    @input="toUpperCaseGeneral(benefNuevo, 'APaterno')"></v-text-field>
                            </v-col>
                            <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                                <v-text-field v-model="benefNuevo.AMaterno" :rules="[rules.ruleNombre]"
                                    label="Apellido materno" outlined dense
                                    @input="toUpperCaseGeneral(benefNuevo, 'AMaterno')"></v-text-field>
                            </v-col>
                            <v-col cols="6" xs="6" sm="3" md="4" lg="2" xl="2">
                                <v-text-field v-model="benefNuevo.FechaNac" label="Fecha Nacimiento" type="date" dense
                                    outlined />
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-btn color="primary" @click="agregarBeneficiario">Agregar Beneficiario</v-btn>

                    <v-data-table :headers="headersBeneficiarios" :items="seleccionado?.Beneficiarios" dense
                        class="mt-3">
                        <template v-slot:[`item.acciones`]="{ item }">
                            <v-btn icon small color="red" @click="eliminarBeneficiario(item)">
                                <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text @click="dialogBeneficiarios = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import truncateText from '@/mixins/truncateText';
import upperCase from '@/mixins/upperCase';
export default {
    mixins: [upperCase],
    computed: {
        rules() {
            return this.$rules;
        },
        mem() {
            return this.$route.params.mem;
        }
    },
    components: {
        SelectColectivos: () => import('@/components/selectColectivo.vue'),
        SelectParentesco: () => import('@/components/selectParentesco.vue')
    },
    mounted() {
        this.NombreMem = this.$route.params.mem || null;
        if (this.NombreMem) {
            this.getMembresias()
        }
        this.getColectivos()
    },
    data() {
        return {
            nuevo: {
                IdColectivo: null,
                Nombres: null,
                APaterno: null,
                AMaterno: null,
                Tipo: "INDIVIDUAL",
                FecNac: null,
                Sexo: null,
                Beneficiarios: [],
                Parentesco: "TITULAR",
            },
            benefNuevo: {
                Nombres: null,
                APaterno: null,
                AMaterno: null,
                FecNac: null,
                Sexo: null,
                Parentesco: null,
            },
            headers: [
                { text: 'Parentesco', value: 'Parentesco', sortable: false },
                // { text: 'Membresia', value: 'GUID', sortable: true },
                { text: 'Nombres', value: 'Nombres', sortable: true },
                { text: 'Paterno', value: 'APaterno', sortable: true },
                { text: 'Materno', value: 'AMaterno', sortable: true },
                { text: 'Fecha de nacimiento', value: 'FechaNac', sortable: truncateText },
                { text: 'Sexo', value: 'Sexo', sortable: true },
                { text: 'Tipo', value: 'Tipo', sortable: false },
                { text: 'Acciones', value: 'acciones', sortable: false }
            ],
            headersBeneficiarios: [
                { text: 'Parentesco', value: 'Parentesco', sortable: false },
                { text: 'Nombres', value: 'Nombres', sortable: true },
                { text: 'Paterno', value: 'APaterno', sortable: true },
                { text: 'Materno', value: 'AMaterno', sortable: true },
                { text: 'Fecha de nacimiento', value: 'FechaNac', sortable: truncateText },
                { text: 'Sexo', value: 'Sexo', sortable: true },
                { text: 'Acciones', value: 'acciones', sortable: false }
            ],
            renglones: [],
            seleccionado: null,
            dialogBeneficiarios: false,


            planesUnicos: {},
            activas: 0,
            suspendidas: 0,
            totalbajas: 0,
            colectivos: [],
            Parentescos:[],

            contratos: [],

            idcolectividadSelect: null,
            idParentescoSelect: null,

            isValid: false,
            isValidBen: false,
        }
    },
    methods: {
        eliminarRenglon(item) {
            this.renglones = this.renglones.filter(r => r !== item);
        },
        async agregarRenglon() {
            if (!this.nuevo) return;
            if (this.$refs.form.validate()) {
                console.log(this.nuevo)
                this.renglones.IdColectivo = this.idcolectividadSelect
                this.renglones.Tipo = "ALTA"
                this.renglones.push({ ...this.nuevo, Beneficiarios: [] });
                this.nuevo = { Nombres: null, APaterno: null, AMaterno: null, FecNac: null, Sexo: null ,Parentesco: "TITULAR" };
            }
        },
        guardar() {
            this.renglones.IdColectivo = this.idcolectividadSelect
            this.renglones.Tipo = "ALTA"
                        console.log(this.renglones)
            const payload = JSON.parse(JSON.stringify(this.renglones));
            console.log(payload)
            this.$http.post(`colectivo/movimiento`,   payload )
                .then(response => {
                    if (response.status === 200) {
                        this.colectivos = response.data
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                });
        },
        abrirBeneficiarios(item) {
            this.seleccionado = item;
            this.dialogBeneficiarios = true;
            this.getParentesco()
        },
        agregarBeneficiario() {
            this.benefNuevo.Parentesco = this.idParentescoSelect       
            if (!this.benefNuevo.Nombres) return;
            const existe = this.seleccionado.Beneficiarios.some(r => r.Parentesco === this.benefNuevo.Parentesco);

                if (existe) {
                    // this.$toast?.error?.(`Ya existe un beneficiario con parentesco ${this.benefNuevo.Parentesco}`);
                            this.$swal.fire({
                                position: 'center',
                                // title: 'Valida',
                                //text: 'Se genero un error',
                                html: `Ya existe un beneficiario con el mismo  <b>parentesco</b> .`,
                                icon: 'error',
                                confirmButtonText: 'Cerrar',
                                showCloseButton: true,
                                showConfirmButton: true,
                                //timer: 1500,
                            })
                    return;
                }
     
            this.seleccionado.Beneficiarios.push({ ...this.benefNuevo });
            this.benefNuevo = { Nombres: null, APaterno: null, AMaterno: null, Parentesco: null, FecNac: null };
        },
        eliminarBeneficiario(item) {
            this.seleccionado.Beneficiarios = this.seleccionado.Beneficiarios.filter(b => b !== item);
        },
        async getColectivos() {
            this.$http.get(`colectivo/admin`)
                .then(response => {
                    if (response.status === 200) {
                        this.colectivos = response.data
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                });
        },
        async getParentesco() {
            this.$http.get(`parentesco`)
                .then(response => {
                    if (response.status === 200) {
                        this.Parentescos = response.data
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                });
        },
        changeColectividad(value) {
            this.planesUnicos = {}
            this.idcolectividadSelect = value
            this.getMembresias()
        },
        changeParentesco(value) {

            this.idParentescoSelect = value

        },
        async getMembresias() {


            this.$http.get(`membresia?qry=${this.NombreMem || null}&idAgent=${this.idagenteSelect || null}&Colectivo=${this.idcolectividadSelect || null}`)
                .then(response => {
                    if (response.status === 200) {
                        this.contratos = [...response.data];  // Copiar los datos para evitar referencias directas

                        this.activas = this.contratos?.filter(item => item.Estatus === 'ACTIVO').length;
                        this.suspendidas = this.contratos?.filter(item => item.Estatus === 'SUSPENDIDO').length;
                        this.totalbajas = this.contratos?.filter(item => item.Estatus === 'BAJA').length;
                        const conteo = {};

                        this.contratos?.forEach(item => {
                            if (item.Plan && item.Estatus === 'ACTIVO') {
                                conteo[item.Plan] = (conteo[item.Plan] || 0) + 1;
                            }
                        });

                        this.planesUnicos = Object.entries(conteo).map(([nombre, cantidad]) => ({
                            nombre,
                            cantidad
                        }));
                    }
                })
                .catch(() => {
                })
                .finally(() => {
                });

        },
        DescargaZip() {
            if (this.idcolectividadSelect) {
                var urltarjet = `${process.env.VUE_APP_FORMATOS}Tarjeta/Colectividad?guid=${this.idcolectividadSelect}`;
                var newTab = window.open(urltarjet);
                if (newTab) {
                    newTab.focus();
                }
            }
        },
        changeSearch() {
            this.idcolectividadSelect = null
            this.idagenteSelect = null
        },
    }
}
</script>

<style lang="scss" scoped></style>